import { render, staticRenderFns } from "./IndPerAppInMan.vue?vue&type=template&id=42446a24&scoped=true&"
import script from "./IndPerAppInMan.vue?vue&type=script&lang=js&"
export * from "./IndPerAppInMan.vue?vue&type=script&lang=js&"
import style0 from "./IndPerAppInMan.vue?vue&type=style&index=0&id=42446a24&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42446a24",
  null
  
)

export default component.exports